export function kirimWA(txt) {
  const link = "https://wa.me/6282143354565";
  window.open(`${link}?text=${encodeURIComponent(txt)}`);
}
